import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEFAULT_UI_LANGUAGE, normalizeUiLanguage } from '../../i18n/language';

const LanguageRouteWrapper: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const pathWithoutLang = location.pathname.replace(/^\/[a-z]{2}(\/|$)/, '/') || '/';
    const suffix = `${pathWithoutLang}${location.search}`;

    if (!lang || lang !== DEFAULT_UI_LANGUAGE) {
      navigate(`/${DEFAULT_UI_LANGUAGE}${suffix}`, { replace: true });
      return;
    }

    const targetLang = normalizeUiLanguage(lang);
    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang).catch(() => {});
      localStorage.setItem('i18nextLng', targetLang);
    }
  }, [lang, location.pathname, location.search, navigate, i18n]);

  return <Outlet />;
};

export default LanguageRouteWrapper;
